import { SeriesSeriesIdFavoriteDeleteInputModel } from "./DeleteInputModel"
import { httpDelete } from "src/libs/http/httpDelete"

const endpointUrl = `/v2/series/{series_id}/favorite`

export const deleteSeriesSeriesIdFavorite = async (
  model: SeriesSeriesIdFavoriteDeleteInputModel,
) => {
  return httpDelete<void>(endpointUrl, model)
}
